'use client';
import { useEffect } from 'react';
import slugify from 'react-slugify';

import { SECONDARY_FLOATING_BUTTON_THEME } from '@/constants/vars.constants';
import { useFloatingCTA } from '@/hooks/floating-cta.hook';
import { NewCarData } from '@/types/new-cars/new-cars.types';

type FloatingButtonProps = {
  newVehicle: NewCarData;
  specials?: {
    id: number;
  }[];
  showWhatsApp?: boolean;
};

const FloatingButton = ({
  newVehicle,
  specials,
  showWhatsApp,
}: FloatingButtonProps) => {
  const {
    setFormItem,
    setSecondaryFloatingButton,
    setWhatsAppButton,
    openWhatsAppForm,
  } = useFloatingCTA();

    const singleSpecial = specials?.length === 1 ? specials[0] : undefined;

    const promotionUrl = singleSpecial
      ? `/promotions/${slugify(newVehicle.main_title)}/${singleSpecial.id}`
      : `/promotions`;

    useEffect(() => {
      if (specials?.length) {
        setSecondaryFloatingButton({
          url: promotionUrl,
          text: 'Promotions',
          display: 'all',
          colors: {
            ...SECONDARY_FLOATING_BUTTON_THEME,
          },
        });
      }

    if (showWhatsApp) {
      setWhatsAppButton({
        text: 'WhatsApp',
        display: 'all',
        onClick: openWhatsAppForm,
      });
    }

    setFormItem({
      type: 'new-car',
      newCar: newVehicle,
    });

    return () => {
      setSecondaryFloatingButton(null);
      setWhatsAppButton(null);
      setFormItem(undefined);
    };
  }, [
    newVehicle,
    specials,
    promotionUrl,
    showWhatsApp,
    setFormItem,
    setSecondaryFloatingButton,
    setWhatsAppButton,
    openWhatsAppForm,
  ]);

  return <div />;
};

export default FloatingButton;